
export * from './generated';
export * from './GetFirmwareParams';
export * from './UpdateDeviceFirmwareParams';

export enum VIRTUAL_FIRMWARE {
  PS_BASIC = '0daa92ee7318f62a30310d6355b14977',
  CAR_COUNTER = '49e449f2641d01363fe96445f2fb1dc1',
};
